import { render } from "./Yamazaki.vue?vue&type=template&id=e2b5084e"
import script from "./Yamazaki.vue?vue&type=script&setup=true&lang=js"
export * from "./Yamazaki.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/blogs/Yamazaki.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2b5084e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2b5084e', __exports__)) {
    api.reload('e2b5084e', __exports__)
  }
  
  module.hot.accept("./Yamazaki.vue?vue&type=template&id=e2b5084e", () => {
    api.rerender('e2b5084e', render)
  })

}


export default __exports__